require('./init-iframe');
require('./init-menu');
require('./init-check-device');
require('./init-external-link-modal');
require('./init-responsive-table');
require('./init-show-hide');
require('./init-scroll-up');
require('./init-scroll-section');
require('./init-svg4everybody');
require('./init-validation-tooltip');
require('./init-video');



// WEBPACK FOOTER //
// ./js/components/index.js